import * as React from "react";
import { observer } from "mobx-react";

import { UitkCardAlohaPlaceholder } from "uitk-react-cards";
import { IsomorphicCarousel } from "components/shared/IsomorphicCarousel/IsomorphicCarousel";

// placeholder for the campaigns which will be displayed until the data is fetched
export const CampaignPlaceholder = observer(
  ({
    numberOfCampaigns,
    formatText,
  }: {
    numberOfCampaigns: number;
    formatText: (key: string, ...args: any[]) => string;
  }) => {
    return (
      <div data-testid="merch-campaign-placeholder" className="CampaignPlaceholder all-b-margin-three">
        {[...Array(numberOfCampaigns)].map((e, i) => (
          <div className="all-y-padding-six" key={i}>
            <UitkCardAlohaPlaceholder className="all-l-margin-three placeholder-header" />
            <UitkCardAlohaPlaceholder className="all-l-margin-three all-t-margin-two placeholder-subheader" />
            <IsomorphicCarousel
              className="carousel-component all-t-margin-three"
              itemsVisible={{
                lg: 3,
                md: 2,
                sm: 1,
              }}
              buttonText={{
                nextButton: formatText("carousel.item.next"),
                prevButton: formatText("carousel.item.prev"),
              }}
              pageBy={1}
              peekWidth={24.8}
            >
              {[...Array(4)].map((val, index) => (
                <div key={index} className="uitk-carousel-item uitk-cell">
                  <UitkCardAlohaPlaceholder className="placeholder-card" />
                </div>
              ))}
            </IsomorphicCarousel>
          </div>
        ))}
      </div>
    );
  }
);
